<template>

    <div class="input-numeric">
        <input class="input-numeric-input" v-model.number="value" :tabindex="tabindex" />
        <div class="input-numeric-control">
            <a href="#" @click.prevent="increment"><v-arrow dir="u"></v-arrow></a>
            <a href="#" @click.prevent="decrement"><v-arrow dir="d"></v-arrow></a>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .input-numeric {
        position: relative;
        .input-numeric-input {
            @include font-medium(13px);
            appearance: none;
            border: 1px solid $color-rule;
            border-radius: 3px;
            box-sizing: border-box;
            color: $color-text;
            height: 40px;
            padding: 0 34px 0 12px;
            transition: border-color .3s;
            width: 100%;
            &:hover, &:focus {
                border-color: $color-text;
            }
        }
        .input-numeric-control {
            display: flex;
            flex-direction: column;
            height: 100%;
            padding: 8px 0;
            position: absolute;
            right: 0;
            top: 0;
            width: 34px;
            a {
                align-items: center;
                color: $color-rule;
                display: flex;
                height: 50%;
                justify-content: center;
                opacity: 0.5;
                text-decoration: none;
                width: 100%;
                &:hover {
                    opacity: 1;
                }
            }
        }
    }

</style>

<script>

export default {

    props: {
        model: {
            type: Number,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: null,
        },
        tabindex: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            value: this.model,
        }
    },

    watch: {

        value(val) {
            if (val >= this.min && (this.max === null || val <= this.max)) {
                this.$emit('input', val);
            }
        },

    },

    methods: {

        increment() {
            let num = parseInt(this.value);
            if (this.max === null || num < this.max) {
                this.value = num + 1;
            }
        },

        decrement() {
            let num = parseInt(this.value);
            if (num > this.min) {
                this.value = num - 1;
            }
        },

    },

}

</script>
